import React from 'react';
import styled from 'styled-components';

import { Grid, Row } from 'react-bootstrap';
import { CenteredCol, TimeMark } from '../StyledPrimitives/StyledPrimitives';

const ColoredRow = styled(Row)`
    padding: 20px 0 20px 0;
    background: #0f42a8;
`;

const header = (props) => (
    <Grid fluid>
        <ColoredRow>
            <CenteredCol xs={12}>
                <h3>Idan Kimel, Game Developer <TimeMark>since 1983</TimeMark></h3>
            </CenteredCol>
        </ColoredRow>
    </Grid>
);

export default header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js